export default {
    entityKey: 'organizations',
    titles: {
        singular: 'Organization',
        plural: 'Organizations'
    }
}